// material-ui
import { styled } from '@mui/material/styles';
import { Avatar, Button, Card, CardActionArea, CardContent, CardHeader, Grid, Stack, Typography } from '@mui/material';

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';

import CoinAoneDark200 from '../../../../assets/images/CoinAoneDark200.png';
import CoinSamsungDark200 from '../../../../assets/images/CoinSamsungDark200.png';
import NumberFormat from 'react-number-format';
import { useEffect, useState } from 'react';
import StatementHistory from './StatementHistory';
// styles
const CardStyle = styled(Card)(({ theme }) => ({
    background: theme.palette.warning.light,
    marginTop: '16px',
    marginBottom: '16px',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '200px',
        height: '200px',
        border: '19px solid ',
        borderColor: theme.palette.warning.main,
        borderRadius: '50%',
        top: '65px',
        right: '-150px'
    },
    '&:before': {
        content: '""',
        position: 'absolute',
        width: '200px',
        height: '200px',
        border: '3px solid ',
        borderColor: theme.palette.warning.main,
        borderRadius: '50%',
        top: '145px',
        right: '-70px'
    }
}));

// ==============================|| PROFILE MENU - UPGRADE PLAN CARD ||============================== //

const UpgradePlanCard = ({ TotalAoneWallte, setOpenStatement }) => {
    // useEffect(() => {
    //     // console.log(TotalAoneWallte.TotalAoneWallte);
    // }, []);

    return (
        <>
            <CardStyle>
                <CardContent>
                    <Grid container direction="column" spacing={2}>
                        <Grid item>
                            <Typography variant="h4">{localStorage.getItem('fullname')}</Typography>
                        </Grid>
                        <Grid item>
                            <Typography variant="subtitle2" color="grey.900" sx={{ opacity: 0.6 }}>
                                {localStorage.getItem('branchCode')}
                            </Typography>
                            <Typography variant="subtitle2" color="grey.900" sx={{ opacity: 0.6 }}>
                                {`Location: ${localStorage.getItem('locationCode')}`}
                            </Typography>
                            <Typography variant="subtitle2" color="grey.900" sx={{ opacity: 0.6 }}>
                                {localStorage.getItem('userId')}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Stack direction="row">
                                {/* <AnimateButton>
                        <Button variant="contained" color="warning" sx={{ boxShadow: 'none' }}>
                            Go Premium
                        </Button>
                    </AnimateButton> */}
                                <Card sx={{ background: 'transparent' }}>
                                    <CardActionArea
                                        onClick={() => {
                                            setOpenStatement(true);
                                        }}
                                    >
                                        <CardHeader
                                            avatar={
                                                <Avatar
                                                    alt="Aone Coin"
                                                    src={CoinAoneDark200}
                                                    sx={{ width: 20, height: 20, background: 'transparent' }}
                                                />
                                            }
                                            title={
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{
                                                        color: '#3035BC'
                                                    }}
                                                >
                                                    <NumberFormat
                                                        thousandsGroupStyle="thousand"
                                                        value={TotalAoneWallte}
                                                        prefix="₭"
                                                        decimalSeparator="."
                                                        displayType="text"
                                                        type="text"
                                                        thousandSeparator={true}
                                                        allowNegative={true}
                                                    />
                                                </Typography>
                                            }
                                        />
                                    </CardActionArea>
                                </Card>
                                <Card sx={{ background: 'transparent' }}>
                                    <CardActionArea>
                                        <CardHeader
                                            avatar={
                                                <Avatar
                                                    alt="Samsung Coin"
                                                    src={CoinSamsungDark200}
                                                    sx={{ width: 20, height: 20, background: 'transparent' }}
                                                />
                                            }
                                            title={
                                                <Typography
                                                    variant="subtitle1"
                                                    sx={{
                                                        color: '#000'
                                                    }}
                                                >
                                                    ₭0
                                                </Typography>
                                            }
                                        />
                                    </CardActionArea>
                                </Card>
                            </Stack>
                        </Grid>
                    </Grid>
                </CardContent>
            </CardStyle>
        </>
    );
};

export default UpgradePlanCard;
